import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

export interface BreadcrumbItem {
    label: string;
    link?: (string | number)[] | string;
    isActive?: boolean;
}

@Component({
    selector: "vsf-breadcrumbs",
    standalone: true,
    imports: [CommonModule, RouterModule],
    templateUrl: "./breadcrumbs.component.html",
    styleUrls: ["./breadcrumbs.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbsComponent {
    @Input() items: BreadcrumbItem[] = [];
    isCurrent(item: BreadcrumbItem, last: boolean): boolean {
        return item.isActive === true || (last && !item.link && !this.items.some(crumb => crumb.isActive));
    }
}
